import React from 'react';
import { CalendarIcon, ClockIcon, ChevronLeftIcon, ChevronRightIcon, UserIcon } from 'lucide-react';
export function SchedulingWidget() {
  const timeSlots = ['09:00 AM', '09:30 AM', '10:00 AM', '11:30 AM', '01:00 PM', '02:30 PM', '03:00 PM', '04:00 PM'];
  return <div className="bg-surface border border-bordercolor rounded-xl shadow-card overflow-hidden" data-id="element-105">
      {/* Widget Header */}
      <div className="bg-primary-light p-4 border-b border-bordercolor" data-id="element-106">
        <div className="flex items-center gap-3 mb-1" data-id="element-107">
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white" data-id="element-108">
            <UserIcon className="w-5 h-5" data-id="element-109" />
          </div>
          <div data-id="element-110">
            <h3 className="font-semibold text-brandtext" data-id="element-111">
              Initial Telehealth Evaluation
            </h3>
            <p className="text-sm text-brandtext-muted flex items-center gap-1" data-id="element-112">
              <ClockIcon className="w-3.5 h-3.5" data-id="element-113" /> 30 minutes
            </p>
          </div>
        </div>
      </div>

      {/* Calendar Mockup */}
      <div className="p-5" data-id="element-114">
        <div className="flex items-center justify-between mb-4" data-id="element-115">
          <h4 className="font-medium text-brandtext flex items-center gap-2" data-id="element-116">
            <CalendarIcon className="w-4 h-4 text-primary" data-id="element-117" />
            Select a Date & Time
          </h4>
          <div className="flex gap-2" data-id="element-118">
            <button className="p-1 rounded hover:bg-gray-100 text-brandtext-muted" data-id="element-119">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-120" />
            </button>
            <span className="text-sm font-medium mt-0.5" data-id="element-121">October 2023</span>
            <button className="p-1 rounded hover:bg-gray-100 text-brandtext-muted" data-id="element-122">
              <ChevronRightIcon className="w-5 h-5" data-id="element-123" />
            </button>
          </div>
        </div>

        <div className="grid grid-cols-7 gap-1 mb-6 text-center text-xs font-medium text-brandtext-muted" data-id="element-124">
          <div data-id="element-125">Su</div>
          <div data-id="element-126">Mo</div>
          <div data-id="element-127">Tu</div>
          <div data-id="element-128">We</div>
          <div data-id="element-129">Th</div>
          <div data-id="element-130">Fr</div>
          <div data-id="element-131">Sa</div>
        </div>

        <div className="grid grid-cols-7 gap-1 mb-6 text-center text-sm" data-id="element-132">
          {/* Empty slots for offset */}
          <div className="p-2 text-gray-300" data-id="element-133">28</div>
          <div className="p-2 text-gray-300" data-id="element-134">29</div>
          <div className="p-2 text-gray-300" data-id="element-135">30</div>
          {/* Active days */}
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map(day => <div key={day} className={`p-2 rounded-full cursor-pointer ${day === 12 ? 'bg-primary text-white font-semibold' : 'hover:bg-primary-light text-brandtext'}`} data-id="element-136">
              {day}
            </div>)}
          {/* More days... */}
          <div className="p-2 text-brandtext hover:bg-primary-light rounded-full cursor-pointer" data-id="element-137">
            15
          </div>
          <div className="p-2 text-brandtext hover:bg-primary-light rounded-full cursor-pointer" data-id="element-138">
            16
          </div>
          <div className="p-2 text-brandtext hover:bg-primary-light rounded-full cursor-pointer" data-id="element-139">
            17
          </div>
          <div className="p-2 text-brandtext hover:bg-primary-light rounded-full cursor-pointer" data-id="element-140">
            18
          </div>
        </div>

        <div className="border-t border-bordercolor pt-4" data-id="element-141">
          <h5 className="text-sm font-medium text-brandtext mb-3" data-id="element-142">
            Available Times for Oct 12
          </h5>
          <div className="grid grid-cols-2 gap-2" data-id="element-143">
            {timeSlots.map((time, i) => <button key={i} className={`py-2 px-3 text-sm rounded border ${i === 2 ? 'border-primary bg-primary-light text-primary font-medium' : 'border-bordercolor hover:border-primary text-brandtext-muted'} transition-colors`} data-id="element-144">
                {time}
              </button>)}
          </div>
        </div>

        <div className="mt-6" data-id="element-145">
          <button className="w-full py-3 bg-primary text-white font-medium rounded-md hover:bg-primary-dark transition-colors" data-id="element-146">
            Confirm Appointment
          </button>
        </div>
      </div>

      {/* Placeholder Notice */}
      <div className="bg-gray-50 p-3 text-center border-t border-bordercolor" data-id="element-147">
        <p className="text-xs text-brandtext-muted italic" data-id="element-148">
          Example telehealth scheduling widget
          <br data-id="element-149" />
          (placeholder – replace with secure platform for actual bookings)
        </p>
      </div>
    </div>;
}